/* eslint-disable react-refresh/only-export-components */
export * from './common';
export * from './pushLog';

import type { PopoverProps } from 'antd';
import { clearAll as clearAll_, clearDB as clearDB_ } from '../clearData';
import { isDebug } from './common';
import { logService } from './pushLog';

export const DebugTooltip = ({
  children,
  info,
  excludeFields = [],
  ...restProps
}: {
  children: ReactNode;
  info: any;
  excludeFields?: string[];
} & PopoverProps) => {
  if (isDebug) {
    if (typeof info === 'object') {
      info = JSON.stringify(
        info,
        (key, value) => {
          if (excludeFields.includes(key)) {
            return undefined;
          }
          return value;
        },
        2
      );
    }
    return (
      <Popover
        trigger={'contextMenu'}
        content={
          <pre style={{ maxWidth: 400, overflow: 'auto', maxHeight: 400, margin: 0 }}>
            <div>
              <Button
                size="small"
                onClick={() => {
                  navigator.clipboard.writeText(info);
                  message.success('Copied to clipboard');
                }}
              >
                Copy
              </Button>
            </div>
            {info}
          </pre>
        }
        {...restProps}
      >
        {children}
      </Popover>
    );
  }
  return children;
};

let count = 0;

export function timerUtil(title: string) {
  const label = `timer:${count++}-${title}`;
  console.log(label, 'Loading...');
  console.time(label);
  return () => {
    console.timeEnd(label);
    console.log(label, '...End');
  };
}

export function exportApis(apiMap: Record<string, any>) {
  if (isDebug) {
    const apiMap_ = (globalThis as any).apiMap || ((globalThis as any).apiMap = {});
    Object.assign(apiMap_, apiMap);
  }
}

export async function clearDB() {
  try {
    await clearDB_();
  } catch (err) {
    alert('Clear is Failed.');
    throw err;
  }
}

export async function clearAll() {
  try {
    await clearAll_();
  } catch (err) {
    alert('Clear is Failed.');
    throw err;
  }
}

if (isDebug) {
  window.addEventListener('keydown', async (e) => {
    if (e.key === 'Delete') {
      try {
        if (e.ctrlKey) {
          await clearAll();
        } else if (e.shiftKey) {
          await clearDB();
        }
      } catch (err) {
        alert();
        throw err;
      }
    }
  });
}

export const useDisableDevTools = () => {
  useEffect(() => {
    const handleRightClick = (event: MouseEvent) => {
      if (isDebug) {
        return;
      }
      event.preventDefault();
    };

    const handleKeyDown = (event: KeyboardEvent) => {
      if (isDebug) {
        return;
      }
      if (
        event.key === 'F12' ||
        (event.ctrlKey && event.shiftKey && event.key === 'I') ||
        (event.ctrlKey && event.shiftKey && event.key === 'C') ||
        (event.ctrlKey && event.shiftKey && event.key === 'J') ||
        (event.ctrlKey && event.key === 'U')
      ) {
        event.preventDefault();
      }
    };

    // const handleBeforeUnload = (event: BeforeUnloadEvent) => {
    //   if (!isDebug) {
    //     event.preventDefault();
    //     event.returnValue = '';
    //   }
    // };

    window.addEventListener('contextmenu', handleRightClick);
    window.addEventListener('keydown', handleKeyDown);
    // window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('contextmenu', handleRightClick);
      window.removeEventListener('keydown', handleKeyDown);
      // window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);
};

exportApis({
  logService,
});
